module.exports = __webpack_public_path__ + "static/media/clock.c69433e4.webp";